import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Notification from './Notification';
import { NotificationService } from '../../services/NotificationService';
import ThemeDefinition from '../../domain/ThemeDefinition';

import styles from './NotificationContainer.module.css';

interface IProps {
  service?: NotificationService;
}

@observer
class NotificationContainer extends React.Component<IProps> {
  render() {
    const { service } = this.props;

    if (!service) {
      return null;
    }

    const notification = service.currentNotification;

    return notification ? (
      <div className={classNames(styles.wrapper, ThemeDefinition.notificationContainer.root)}>
        {notification.modal && (
          <div className={classNames(styles.backdrop, ThemeDefinition.notificationContainer.backdrop)} />
        )}
        <Notification
          className={styles.notification}
          type={notification.type}
          content={notification.content}
          canBeMuted={notification.canBeMuted}
          onClose={service.onClose}
        />
      </div>
    ) : null;
  }
}

export default NotificationContainer;
